import type { AssetFile } from 'contentful';
import { getCloudFlareProxiedUrl } from 'helpers/imageProxyHelper';
import { imageSizesArray } from './types';

function createSrcSet(props: AssetFile): string | undefined {
    // contentful Image api -> https://www.contentful.com/developers/docs/references/images-api/
    const { details, url } = props;

    if (!url || !details) return undefined;

    const srcsetArray: string[] = [];
    const originalWidth = details.image?.width || imageSizesArray.slice(-1)[0];
    const sizesLowerThanOriginal = imageSizesArray.filter((size) => size <= originalWidth);

    sizesLowerThanOriginal.forEach((size) => {
        const sizedUrl = `${url}?w=${size}&q=80`;
        const proxiedUrl = getCloudFlareProxiedUrl(sizedUrl);
        srcsetArray.push(`${proxiedUrl} ${size}w`);
    });

    return srcsetArray.join(', ');
}

export { createSrcSet };
